import { ColorPalette } from 'types/muiTheme'

export const darkTheme: ColorPalette = {
  mode: 'dark',
  primary: {
    main: '#3988bd',
  },
  secondary: {
    main: '#66C2C4',
  },
  text: {
    primary: '#DfE5E6',
    dim: 'rgba(255, 255, 255, 0.7)',
    secondary: '#B0B0B0',
    disabled: '#6A6A6A',
  },
  common: {
    white: '#FFFFFF',
  },
  action: {
    hover: 'rgba(255, 255, 255, 0.15)',
    focus: 'rgba(255, 255, 255, 0.15)',
  },
  shadows: {
    0: 'none',
    1: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
  },
  background: {
    default: '#0F1011',
    paper: '#232325',
  },
  divider: '#484848',
  custom: {
    sidebar: {
      backgroundColor: '#0F1011',
      textDimColor: 'rgba(255, 255, 255, 0.7)',
      color: '#F0F0F4',
      iconBackground: 'rgba(0, 0, 0, 0.9)',
      avatarBgColor: 'rgba(255, 255, 255, 0.15)',
    },
    link: {
      color: '#78b6ff',
    },
    button: {
      primaryText: '#242829',
      primaryTextHover: '#242829',
      primaryBackground: '#66C2C4',
      focusedOutline: '#66C2C4',
    },
    input: {
      backgroundColor: '#4B4B4B',
      border: '1px solid rgba(210, 210, 210, 0.4)',
    },
    widgetToolbar: {
      backgroundColor: '#232325',
      boxShadow: 'none',
    },
    widget: {
      headerColor: '#232325',
      backgroundColor: '#303035',
    },
    widgetButton: {
      backgroundColor: '#0A0B0B',
      boxShadow: '0 0px 6px rgba(0, 0, 0, 0.5)',
      border: '1px solid rgba(210, 210, 210, 0.4)',
    },
    widgetDropTarget: {
      backgroundColor: 'rgba(102, 194, 196, 0.5)',
      border: '2px solid #66C2C4',
    },
    mosaicWindowToolbar: {
      backgroundColor: '#232325',
      boxShadow: '0 0px 4px rgba(0, 0, 0, 0.1)',
    },
    gridTable: {
      background: '#232325',
      columnHeaderBackground: '#1C1C1C',
      borderColor: 'rgba(255, 255, 255, 0.2)',
      textHighlight: '#2495e0',
    },
    subscription: {
      borderColor: '#F6B900',
    },
  },
}
